module.exports = __webpack_public_path__ + "static/media/age-icon.18bbc21e.svg";